import { offerSelector } from './offer';
import { IState } from '../../../store';

export const selectCianPartner = (state: IState) => {
  return offerSelector(state).isCianPartner;
};
